export default __webpack_public_path__ + "static/media/sig-1.2f027c2b.jpg";